import { useContext } from 'react'
import NotificationsSettingsContext from '../contexts/NotificationsSettingsContext'

export const useNotificationsSettingsContext = () => {
  const ctx = useContext(NotificationsSettingsContext)
  if (!ctx) {
    throw new Error('useNotificationsSettingsContext debe usarse dentro de NotificationsSettingsProvider')
  }
  return ctx
}

export default useNotificationsSettingsContext

